import { HttpErrorCode } from '@copera/common/error';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SoundBoardData, SoundBoardRequests } from 'src/requests/soundboard';
import { QueryKey } from 'src/utils/react-query';

export const useUpdateSoundMutation = () => {
  const queryClient = useQueryClient();

  const { mutateAsync: updateSound, isLoading: isUpdatingSoundLoading } =
    useMutation(SoundBoardRequests.updateSound, {
      meta: {
        httpErrors: {
          [HttpErrorCode.INVALID]: 'error.soundboard.invalid_sound_id',
          [HttpErrorCode.NOT_FOUND]: 'error.soundboard.sound_not_found',
          [HttpErrorCode.FORBIDDEN]: 'error.soundboard.not_creator',
          [HttpErrorCode.ALREADY_EXISTS]:
            'error.soundboard.name_already_exists',
        },
      },
      onSuccess(updatedSound) {
        const prevSounds = queryClient.getQueryData<SoundBoardData[]>([
          QueryKey.SOUNDBOARD,
        ]);

        queryClient.setQueryData<SoundBoardData[]>(
          [QueryKey.SOUNDBOARD],
          (content) => {
            return content
              ? [
                  ...content.map((sound) =>
                    sound._id === updatedSound._id ? updatedSound : sound,
                  ),
                ]
              : [updatedSound];
          },
        );

        return { prevSounds };
      },
    });

  return {
    updateSound,
    isUpdatingSoundLoading,
  };
};
